import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20style%20digital%20illustration%20with%20a%20dramatic%20fantasy%20landscape%2C%20warm%20sunset%20sky%20with%20golden%20and%20coral%20tones%2C%20traditional%20Korean%20architecture%20elements%20blended%20with%20modern%20fantasy%2C%20cherry%20blossom%20petals%20floating%2C%20majestic%20mountain%20background%2C%20ethereal%20atmosphere%2C%20professional%20digital%20art%2C%20cinematic%20composition%2C%20wide%20panoramic%20view&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
        alt="韩国漫画网 - 韩漫免费在线阅读平台"
        title="韩漫免费漫画在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
        fetchPriority="high"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-screen-2xl mx-auto px-4 md:px-6 py-20 text-center">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-background-50 leading-tight">
          韩漫免费漫画
          <br />
          <span className="text-primary-300">在线阅读韩漫大全</span>
        </h1>
        <p className="mt-6 text-sm md:text-base text-background-200/90 max-w-2xl mx-auto leading-relaxed">
          在韩国漫画网发现好看的韩国漫画，下拉式阅读模式让您的浏览体验更加轻松愉悦。
          恋爱、奇幻、动作、悬疑……丰富分类，每日更新，畅享韩漫的无限魅力。
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105"
          >
            开始阅读
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="border border-background-200/40 text-background-50 hover:bg-background-50/10 px-8 py-3 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-16 flex items-center justify-center gap-8">
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-primary-300">500+</p>
            <p className="text-xs text-background-300 mt-1">漫画作品</p>
          </div>
          <div className="w-px h-10 bg-background-200/20"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-primary-300">50万+</p>
            <p className="text-xs text-background-300 mt-1">活跃读者</p>
          </div>
          <div className="w-px h-10 bg-background-200/20"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-primary-300">每日更新</p>
            <p className="text-xs text-background-300 mt-1">最新章节</p>
          </div>
        </div>
      </div>
    </section>
  );
}